import React from 'react';

import { ListingPageRowActions } from '@futrli/ui-components/components/listing-page/listing-page-row/listing-page-row-actions/listing-page-row-actions';
import {
  ExtendedOrganisationListItem,
  ExtendedWorkspaceListItem
} from '@futrli/views/operations/workspaces/processors/workspacesList';

import { useOrganisationActionItems } from '../../../../hooks/use-organisation-action-items/use-organisation-action-items';

interface OrganisationRowActionsProps {
  workspace: ExtendedWorkspaceListItem;
  organisation: ExtendedOrganisationListItem;
}

export const OrganisationRowActions = ({ workspace, organisation }: OrganisationRowActionsProps) => {
  const items = useOrganisationActionItems({ workspace, organisation });

  return items.length ? <ListingPageRowActions items={items} /> : null;
};
